"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.results.title': 'Wyniki Treningu',
    'trainer.results.success': 'Trening Zakończony Pomyślnie!',
    'trainer.results.success.message': 'Twój niestandardowy model {modelName} został wytrenowany i jest gotowy do użycia.',
    'trainer.results.metrics': 'Końcowe Metryki Wydajności',
    'trainer.results.metric.loss': 'Końcowa Strata',
    'trainer.results.metric.accuracy': 'Końcowa Dokładność',
    'trainer.results.metric.epochs': 'Ukończone Epoki',
    'trainer.results.metric.samples': 'Próbki Treningowe',
    'trainer.results.export': 'Eksportuj Model',
    'trainer.results.deploy': 'Wdróż Model',
    'trainer.results.test': 'Testuj Model',
};
